<template>
  <div id="app">
    <!-- 邀请返得现金 -->
    <div class="UpSharemoney">
      <p @click="UpSharemoneyrule">{{ $t('column.invitation_rules')}}</p>
      <div class="money_code">{{ $t('column.Invitation_code') }}</div>
      <div class="money_add">{{ UpSharemoney.user_id }}</div>

      <div class="money">
        <dl class="money_dl">
          <dt>{{ $t('column.can_withdrawal_amount') }}({{ $t("other.yuan") }})</dt>

          <dd>{{ UpSharemoney.coin }}</dd>
        </dl>
        <img src="../assets/img/invite_fngex.png" alt="">
        <dl class="money_dl">
          <dt>{{ $t("column.Number_people_invited")}}({{ $t("other.people")}})</dt>
          <dd>{{ UpSharemoney.number }}</dd>
        </dl>
        <div class="reflect" @click="reflectBTn">{{ $t("btn.Withdrawal") }}</div>
      </div>
    </div>
    <div class="UpSharemoney_cen">
      <div class="UpSharemoneyBtn" @click="UpSharemoneyBtn">	{{ $t("column.Invite_friends_make_money_now")}}	</div>
      <div class="UpSharemoneyTeam">	{{ $t("column.My_team")}}	</div>
      <div class="UpSharemoney_classify">
        <div class="UpSharemoney_classify_left" @click="invitationOne(1)">
          <p>{{ $t("column.First_level_team")}}</p>
          <div>	{{ $t("column.details") }} > </div>
        </div>
        <div class="UpSharemoney_classify_right">
          <div class="UpSharemoney_classify_right_T" v-if="UpSharemoney.is_invitation_two==1" @click="invitationOne(2)">
            <p>{{ $t("column.Secondary_team") }}</p>
            <div>	{{ $t("column.details") }} >	</div>
          </div>
          <div class="UpSharemoney_classify_right_B" v-if="UpSharemoney.is_invitation_three==1" @click="invitationOne(3)">
            <p>{{ $t("column.Three_level_team") }}</p>
            <div>	{{ $t("column.details") }} >	</div>
          </div>
        </div>
      </div>
      <div class="UpSharemoneysaid" v-if="Invitation.length"> {{ $t("column.invitation_record")}}	</div>
      <div class="UpSharemoneymould" v-if="Invitation.length">
        <div class="record" v-for="(val,index) in  Invitation" :key="index">
          <div class="record_left">
            <span v-if="val.status===0">{{ $t("other.under_review")}}</span>
            <span v-if="val.status===1">{{ $t("column.Successful_withdrawal")}}</span>
            <span v-if="val.status===2">{{ $t("column.Withdrawal_refusal")}}</span>
            <p>{{ val.alipay_name }}:{{ val.alipay_account }}</p>
          </div>
          <div class="record_right">
            <span> + ${{ val.money }}</span>
            <p>{{ val.addtime }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import '@/assets/css/style.css'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  export default {
    data() {
      return {
        UpSharemoney: [], //获取分销中心数据
        show: false ,//分享链接
        Invitation:[]  ,//邀请体现记录数据
        url:""
      }
    },
    created: function() {
      document.title = this.$t('column.Cash_back_from_invitation')
      this.recordOfInvitation()
      this.UpShare()
    },
    methods: {
      //分享链接
      UpSharemoneyBtn() {
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // 邀请好友
          window.location.href="live://live?action=copy_share_url&copy=" + this.url;
        } else {
          // ios传值方法goSubmitted（val）传值方式
          window.AndroidJs.copy_share(this.url)
        }
      },
      UpShare() {
        const token = this.$route.query.token
        const lang = localStorage.getItem('lang')
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=index&token="+token)
          .then(res => {
            console.log("数据：", res);
            this.UpSharemoney = res.data.data;

            this.url=  res.data.data.url + '&language='+lang;
          }).catch((res) => {
          console.log("请求失败");
        })
      },
      //邀请提现记录
      recordOfInvitation(){
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=record&token="+token)
          .then(res => {
            console.log("数据：", res);
            this.Invitation =JSON.parse(JSON.stringify(res.data.data.list));
          }).catch((res) => {
          console.log("请求失败");
        })
      },
      //id = 1 一级团队  2二级团队 3三级团队
      invitationOne(id) {
        const token = this.$route.query.token
        this.$router.push({
          path: "/firstlevelteam",
          query:{ token: token, id: id }
        })
      },
      //跳转邀请规则页面
      UpSharemoneyrule() {
        const token = this.$route.query.token
        this.$router.push({
          path: "/invitationRules",
          query:{ token: token }
        })
      },
      //点击提现 跳转到提现页面
      reflectBTn(){
        const token = this.$route.query.token
        this.$router.push({
          path: "/reflect",
          query:{ token: token }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UpSharemoney.vue